import { CultivationCyclePopulatedSchema, PostCultivationCycleSchema } from '../../../requests/api/apiTypes';

export const FIELDS_EQ = {
  name: 'Nombre',
  varietyId: 'Variedad',
  startDate: 'Fecha de inicio',
  endDate: 'Fecha de fin',
  useDefaultPhenologicalStates: 'Usar estados default',
  sectorId: 'Sector',
  id: 'Id de ciclo de cultivo',
  producedKg: 'Kg producidos',
  exportablePercentage: '% Exportable',
  productionQuality: 'Calidad',
};

export const REQUIRED_UPSERT_CULT_CYCLE = ['name', 'startDate', 'endDate', 'varietyId'];

export type RouteParams = {
  id: string;
};

export const SECTOR_LIST_UI = (isAdmin: boolean) => [
  {
    label: 'Nombre', key: 'name',
  },
  {
    label: 'Fecha inicio', key: 'startingDate',
  },
  {
    label: 'Fecha fin', key: 'endingDate',
  },
  {
    label: 'Especie', key: 'specie',
  },
  {
    label: 'Variedad', key: 'variety',
  },
  {
    label: 'Kg producidos', key: 'producedKg',
  },
  {
    label: '% Exportable', key: 'exportablePercentage',
  },
  {
    label: 'Calidad', key: 'productionQuality',
  },
  ...(isAdmin ? [
    {
      label: 'Acciones', key: 'actions',
    },
  ] : []),
];

export const CULT_CYCLE_LIST_UI = (isAdmin: boolean) => [
  {
    label: 'Estado', key: 'name',
  },
  {
    label: 'Fecha inicio', key: 'startingDate',
  },
  {
    label: 'Fecha fin', key: 'endingDate',
  },
  {
    label: 'Kc Min', key: 'kcMin',
  },
  {
    label: 'Kc Max', key: 'kcMax',
  },
  ...(isAdmin ? [
    {
      label: 'Acciones', key: 'actions',
    },
  ] : []),
];

export const REQUIRED_UPDATE_SECTOR_FIELDS = [
  'name',
  'theoreticalSurface',
];

export const OPTIONAL_UPDATE_SECTOR_FIELDS = [
  'wiseconnId',
  'variety',
  'plantingYear',
  'plantingFrame',
  'managerName',
  'parentSector',
  'weatherZoneId',
  'sn',
  'irrigationConfig',
  'typeOfSoil',
  'sectorDevice',
  'sectorNumber',
];

export const REQUIRED_UPDATE_SECTOR_EQ: Record<string, string> = {
  name: 'Nombre',
  theoreticalSurface: 'Superficie teórica',
  typeOfSoil: 'Tipo de suelo',
  sectorDevice: 'Equipo',
};

export const sectorSensorTypes = [
  'Soil Temperature',
  'Soil Moisture',
  'Salinity',
  'pH',
  'Irrigation Electrical Conductivity',
  'Tube Humidity',
];

export const weatherSensorTypes = [
  'Temperature',
  'Humidity',
  'Wind Direction',
  'Rain',
  'Solar Radiation',
  'Wind Velocity',
  'Wind Speed',
  'Wind Gust',
  'Atmospheric Pressure',
];

export const plantSensorTypes = [
  'Plant Caliper',
  'Fruit Size',
];

export const irrigationSensorTypes = [
  'Irrigation Precipitation',
  'Irrigation Time',
];

export const sensorTypes = [
  ...sectorSensorTypes,
  ...weatherSensorTypes,
  ...plantSensorTypes,
  ...irrigationSensorTypes,
];

export type SimplifiedCultivationCycle = Pick<CultivationCyclePopulatedSchema, 'id' | 'name' | 'startDate' | 'endDate'> & {
  varietyName: string;
  varietySpecies: string;
  producedKg?: number;
  exportablePercentage?: number;
  productionQuality?: number;
};

export type ModalUpsertCultivationCycleSchema = Pick<PostCultivationCycleSchema, 'name' | 'startDate' | 'endDate' | 'varietyId' | 'useDefaultPhenologicalStates'> & {
  producedKg?: number;
  exportablePercentage?: number;
  productionQuality?: number;
};

export interface CommonCultivationCycleFields {
  name: string;
  startDate: string;
  endDate: string;
  varietyId: string;
  useDefaultPhenologicalStates: boolean;
  producedKg?: number;
  exportablePercentage?: number;
  productionQuality?: number;
}

export type CycleToUpsert = CommonCultivationCycleFields & {
  id?: string;
  sectorId?: string;
};

export type KMZPolygons = {
  id?: string | undefined;
  coordinates?: { lat: number; lng: number; }[] | undefined;
  isSelected?: boolean | undefined;
  isLinked?: boolean | undefined;
  onPolygonClick?: VoidFunction | undefined;
}[];
